<template>
  <div id="categoria-productos">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="10">
            <v-card>
              <v-card-title
                ><a class="breadcrums" @click="returnMenu">{{
                  nameCategoria
                }}</a
                >>
                {{ title }}
              </v-card-title>
              <v-card-text>
                <draggable v-model="listProductos">
                  <transition-group
                    :name="'flip-list'"
                    class="list-inline"
                    tag="ul"
                  >
                    <li v-for="prd of listProductos" :key="prd.id">
                      <v-card>
                        <v-img
                          :src="`${imgDir}galerias/productos/${prd.foto_cat}`"
                        ></v-img>
                        <v-card-title>{{ prd.nombre_esp }}</v-card-title>
                        <v-card-subtitle>{{ prd.codigo }}</v-card-subtitle>
                      </v-card>
                    </li>
                  </transition-group>
                </draggable>
              </v-card-text>
              <v-card-actions>
                <v-container>
                  <v-row>
                    <v-col cols="12" align="center">
                      <v-btn class="ma-2" color="error" to="/admin/categorias"
                        >Regresar</v-btn
                      >
                      <v-btn class="ma-2" color="primary" @click="guardarOrden"
                        >Guardar Orden</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
            <!-- Alertas -->
            <v-snackbar
              v-model="message.snackbar"
              :color="message.color"
              :timeout="message.timeout"
              :top="snackbarPosition === 'top'"
            >
              {{ message.text }}
              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="message.snackbar = false">
                  Close
                </v-btn>
              </template>
            </v-snackbar>
            <!-- End - Alertas -->
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { ref, computed } from "@vue/composition-api";
import draggable from "vuedraggable";
import { imageService } from "@/services/imageService";
import { messageAlert } from "@/services/messageService";

export default {
  name: "CategoriaProductos",
  components: {
    draggable
  },
  setup(props, { root }) {
    const idCategoria = computed(() => parseInt(root.$route.params.id));
    const nameCategoria = computed(() => root.$route.params.cat);
    const title = ref("Ordenar Productos");

    const listProductos = ref([]);
    const { imgDir } = imageService(root);
    const { message, snackbarPosition, showSuccess, showError } = messageAlert(
      root
    );

    const init = () => {
      root.$store
        .dispatch("getCategoriasProductos", idCategoria.value)
        .then(response => {
          listProductos.value = response;
        })
        .catch(error => {
          showError(error);
        });
    };

    const guardarOrden = () => {
      const payload = {
        id: idCategoria.value,
        orderList: listProductos.value
      };
      root.$store
        .dispatch("saveOrderList", payload)
        .then(response => {
          showSuccess(response.msg);
        })
        .catch(error => {
          showError(error);
        });
    };

    const returnMenu = () => {
      root.$router.push(`/admin/categorias`);
    };

    init();

    return {
      title,
      nameCategoria,
      message,
      snackbarPosition,
      listProductos,
      imgDir,
      guardarOrden,
      returnMenu
    };
  }
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}

#categoria-productos ul.list-inline {
  list-style: none;
  margin-top: 15px;
  padding: 0;
}

#categoria-productos ul.list-inline li {
  display: inline-block;
  margin: 5px;
  width: 300px;
  cursor: move;
}

a.breadcrums {
  margin-right: 5px;
}
</style>
